import { computed, ElementRef, inject, input, output, signal, viewChild, } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ALLOWED_FILE_TYPES, MAX_FILE_SIZE_IN_BYTES, MAX_NUMBER_OF_FILES, } from 'AgentApp/ts/constants/agent-file.constants';
import { AccountsService } from 'AccountsApp/ts/services/accounts.service';
import { DropdownHelperService } from 'Angular/services/dropdown-helper.service';
import { AutoDropDirectionModule } from 'Angular/features/directives/auto-drop-direction/auto-drop-direction.module';
import { IconModule } from 'Angular/features/directives/icon/icon.module';
import { TooltipModule } from 'Angular/features/directives/popovers/tooltip/tooltip.module';
import { AgentSmartCompareModalComponent, } from 'AgentApp/ts/features/agent/components/agent-smart-compare-modal/agent-smart-compare-modal.component';
import { AudioTranscriptionInputComponent } from 'Angular/features/components/audio-transcription-input/audio-transcription-input.component';
import { getFileIcon, isAllowedFileType, isFileDragEvent } from 'AgentApp/ts/utils/agent-file';
import * as i0 from "@angular/core";
import * as i1 from "../../../../../../../../../ycharts/static/ts/features/directives/icon/icon.directive";
import * as i2 from "@angular/forms";
import * as i3 from "../../../../../../../../../ycharts/static/ts/features/directives/popovers/tooltip/tooltip.directive";
import * as i4 from "../../../../../../../../../ycharts/static/ts/features/directives/auto-drop-direction/auto-drop-direction.directive";
const _c0 = ["dropdownMenu"];
const _c1 = ["smartCompareModal"];
const _c2 = ["agentFileInput"];
const _c3 = ["audioInput"];
const _c4 = ["textInput"];
function AgentUserInputComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵelement(1, "div");
    i0.ɵɵelementStart(2, "button", 14);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_0_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r2); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.openNewChat.emit()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(3, "svg", 15);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(4, "span", 16);
    i0.ɵɵtext(5, "New Chat");
    i0.ɵɵelementEnd()()();
} }
function AgentUserInputComponent_Conditional_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 7);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 17);
    i0.ɵɵtext(2, "\u00A0Drop files to attach ");
    i0.ɵɵelementEnd();
} }
function AgentUserInputComponent_Conditional_3_For_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21)(2, "div", 22)(3, "div", 23)(4, "div", 24);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(5, "svg", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(6, "div", 26);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(8, "div", 27)(9, "button", 28);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_3_For_4_Template_button_click_9_listener() { const $index_r5 = i0.ɵɵrestoreView(_r4).$index; const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.removeFile($index_r5)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(10, "svg", 29);
    i0.ɵɵelementEnd()()()()();
} if (rf & 2) {
    const file_r6 = ctx.$implicit;
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("name", ctx_r2.getFileIcon(file_r6.name, file_r6.type));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", file_r6.name, " ");
} }
function AgentUserInputComponent_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 18)(1, "div")(2, "div", 19);
    i0.ɵɵrepeaterCreate(3, AgentUserInputComponent_Conditional_3_For_4_Template, 11, 2, "div", 20, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("section-ai-input-files-narrow", ctx_r2.compactLayout());
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r2.uploadedFiles());
} }
function AgentUserInputComponent_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "ycn-audio-transcription-input", 30, 2);
    i0.ɵɵlistener("transcribedText", function AgentUserInputComponent_Conditional_5_Template_ycn_audio_transcription_input_transcribedText_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onTranscribedText($event)); })("transcriptionCancel", function AgentUserInputComponent_Conditional_5_Template_ycn_audio_transcription_input_transcriptionCancel_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onTranscriptionCancel()); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("placeholder", "Ask Y...")("inputText", ctx_r2.textFormControl.value ?? "")("maxCanvasWidth", ctx_r2.maxAudioCanvasWidth());
} }
function AgentUserInputComponent_Conditional_6_Conditional_6_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 43);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_6_Conditional_6_Conditional_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); i0.ɵɵnextContext(3); const agentFileInput_r10 = i0.ɵɵreference(10); return i0.ɵɵresetView(agentFileInput_r10.click()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    i0.ɵɵproperty("tooltipTitle", "Attach Files")("tooltipPlacement", "top")("tooltipIgnoreViewport", true);
} }
function AgentUserInputComponent_Conditional_6_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵconditionalCreate(0, AgentUserInputComponent_Conditional_6_Conditional_6_Conditional_0_Template, 2, 3, "button", 42);
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(!ctx_r2.fileUploadDisabled() ? 0 : -1);
} }
function AgentUserInputComponent_Conditional_6_Conditional_7_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 53);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_6_Conditional_7_Conditional_5_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r12); const ctx_r2 = i0.ɵɵnextContext(3); const agentFileInput_r10 = i0.ɵɵreference(10); agentFileInput_r10.click(); return i0.ɵɵresetView(ctx_r2.isDropdownOpen.set(false)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 17);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "div", 51);
    i0.ɵɵtext(3, "Attach Files");
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(4, "div", 55);
} }
function AgentUserInputComponent_Conditional_6_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 44)(1, "button", 45);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_6_Conditional_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r11); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.toggleDropdown()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 46);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(3, "div", 47, 4);
    i0.ɵɵconditionalCreate(5, AgentUserInputComponent_Conditional_6_Conditional_7_Conditional_5_Template, 5, 0);
    i0.ɵɵelementStart(6, "div", 48)(7, "div", 49);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(8, "svg", 50);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "div", 51);
    i0.ɵɵtext(10, "Smart Flows");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 52)(12, "a", 53);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_6_Conditional_7_Template_a_click_12_listener() { i0.ɵɵrestoreView(_r11); const ctx_r2 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r2.openSmartCompareModal()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(13, "svg", 50);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(14, "div", 51);
    i0.ɵɵtext(15, "Smart Compare");
    i0.ɵɵelementEnd()()()();
    i0.ɵɵelementStart(16, "a", 53);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_6_Conditional_7_Template_a_click_16_listener() { i0.ɵɵrestoreView(_r11); const ctx_r2 = i0.ɵɵnextContext(2); ctx_r2.openSavedPrompts.emit(); return i0.ɵɵresetView(ctx_r2.isDropdownOpen.set(false)); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(17, "svg", 54);
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(18, "div", 51);
    i0.ɵɵtext(19, "Prompt Library");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("show", ctx_r2.isDropdownOpen());
    i0.ɵɵproperty("ycnAutoDropDirection", true);
    i0.ɵɵadvance();
    i0.ɵɵclassProp("active", ctx_r2.isDropdownOpen());
    i0.ɵɵattribute("aria-expanded", ctx_r2.isDropdownOpen());
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("show", ctx_r2.isDropdownOpen());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(!ctx_r2.fileUploadDisabled() ? 5 : -1);
} }
function AgentUserInputComponent_Conditional_6_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 31)(1, "textarea", 32, 3);
    i0.ɵɵlistener("keydown.enter", function AgentUserInputComponent_Conditional_6_Template_textarea_keydown_enter_1_listener($event) { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.onEnter($event)); });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(3, "div", 33)(4, "div", 34)(5, "div", 35);
    i0.ɵɵconditionalCreate(6, AgentUserInputComponent_Conditional_6_Conditional_6_Template, 1, 1)(7, AgentUserInputComponent_Conditional_6_Conditional_7_Template, 20, 9, "div", 36);
    i0.ɵɵelementStart(8, "button", 37);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_6_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.startTranscription()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(9, "svg", 38);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(10, "span", 39)(11, "button", 40);
    i0.ɵɵlistener("click", function AgentUserInputComponent_Conditional_6_Template_button_click_11_listener() { i0.ɵɵrestoreView(_r8); const ctx_r2 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r2.submit()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(12, "svg", 41);
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵclassProp("width-full", ctx_r2.hasNewline());
    i0.ɵɵattribute("data-replicated-value", ctx_r2.textFormControl.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("formControl", ctx_r2.textFormControl);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("width-full", ctx_r2.compactLayout())("pl-2", ctx_r2.compactLayout());
    i0.ɵɵadvance();
    i0.ɵɵclassProp("width-full", ctx_r2.compactLayout())("height-40", !ctx_r2.compactLayout());
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r2.compactLayout() ? 6 : 7);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipTitle", "Dictation")("tooltipPlacement", "top")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("tooltipTitle", ctx_r2.submitButtonTooltip())("tooltipPlacement", "top")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", ctx_r2.isInputDisabled());
} }
export class AgentUserInputComponent {
    constructor() {
        this._fb = inject(FormBuilder);
        this._dropdownHelperService = inject(DropdownHelperService);
        this._accounts = inject(AccountsService);
        /**
         * Client group compliance control. Hides every way of attaching a file - the menu item, the
         * direct attach button, drag-and-drop and paste - so the chat bar offers no upload path. Stays
         * disabled while the preference loads and if the request fails, so a restricted group never gets
         * an upload path the server would reject anyway.
         */
        this.fileUploadDisabled = toSignal(this._accounts.getClientGroupPreferences().pipe(map((preferences) => !!preferences.disable_agent_file_upload), catchError(() => of(true))), { initialValue: true });
        this._hostElement = inject(ElementRef);
        this.maxAudioCanvasWidth = input(468, ...(ngDevMode ? [{ debugName: "maxAudioCanvasWidth" }] : []));
        this.showNewChatButton = input(false, ...(ngDevMode ? [{ debugName: "showNewChatButton" }] : []));
        /**
         * Side panel layout: caps the attachment tray at three rows, spreads the button row full width
         * (tools left, send right), and swaps the "+" tools menu for a direct attach-files button since the
         * panel is too narrow for the prompt tools
         */
        this.compactLayout = input(false, ...(ngDevMode ? [{ debugName: "compactLayout" }] : []));
        /**
         * When false, the chat bar stops handling its own drag-and-drop (and hides its drop overlay) because
         * a parent owns a larger drop zone — e.g. the full agent page, where dropping anywhere forwards files
         * here via {@link addFiles}. The side panel leaves this true so the bar itself is the drop target.
         */
        this.dragDropEnabled = input(true, ...(ngDevMode ? [{ debugName: "dragDropEnabled" }] : []));
        this.dropdownMenu = viewChild('dropdownMenu', ...(ngDevMode ? [{ debugName: "dropdownMenu" }] : []));
        this.smartCompareModal = viewChild('smartCompareModal', ...(ngDevMode ? [{ debugName: "smartCompareModal" }] : []));
        this.fileInput = viewChild('agentFileInput', ...(ngDevMode ? [{ debugName: "fileInput" }] : []));
        this.audioInput = viewChild('audioInput', ...(ngDevMode ? [{ debugName: "audioInput" }] : []));
        this.textInput = viewChild('textInput', ...(ngDevMode ? [{ debugName: "textInput" }] : []));
        this.openNewChat = output();
        this.sendMessage = output();
        this.openSavedPrompts = output();
        this.uploadedFiles = signal([], ...(ngDevMode ? [{ debugName: "uploadedFiles" }] : []));
        this.getFileIcon = getFileIcon;
        this.textFormControl = this._fb.control('');
        this._textValue = toSignal(this.textFormControl.valueChanges, { initialValue: '' });
        this.hasNewline = computed(() => (this._textValue() ?? '').includes('\n'), ...(ngDevMode ? [{ debugName: "hasNewline" }] : []));
        this.isDropdownOpen = signal(false, ...(ngDevMode ? [{ debugName: "isDropdownOpen" }] : []));
        this.isTranscribing = signal(false, ...(ngDevMode ? [{ debugName: "isTranscribing" }] : []));
        this.isDragOver = signal(false, ...(ngDevMode ? [{ debugName: "isDragOver" }] : []));
        this.isInvalidInput = computed(() => (this._textValue() ?? '').length > AgentUserInputComponent.MAX_INPUT_LENGTH, ...(ngDevMode ? [{ debugName: "isInvalidInput" }] : []));
        this.isOverFileLimit = computed(() => this.uploadedFiles().length > MAX_NUMBER_OF_FILES, ...(ngDevMode ? [{ debugName: "isOverFileLimit" }] : []));
        this.oversizedFile = computed(() => this.uploadedFiles().find((file) => file.size > MAX_FILE_SIZE_IN_BYTES) ?? null, ...(ngDevMode ? [{ debugName: "oversizedFile" }] : []));
        this.unsupportedFile = computed(() => this.uploadedFiles().find((file) => !isAllowedFileType(file)) ?? null, ...(ngDevMode ? [{ debugName: "unsupportedFile" }] : []));
        this.submitButtonTooltip = computed(() => {
            const isOverFileLimit = this.isOverFileLimit();
            const oversizedFile = this.oversizedFile();
            const unsupportedFile = this.unsupportedFile();
            const isInvalidInput = this.isInvalidInput();
            if (isOverFileLimit) {
                return `You can only upload up to ${MAX_NUMBER_OF_FILES} files`;
            }
            if (oversizedFile) {
                return `${oversizedFile.name} exceeds the maximum file size of 32MB`;
            }
            if (unsupportedFile) {
                return `${unsupportedFile.name} is not a supported file type. Supported file types: ${ALLOWED_FILE_TYPES.join(', ')}`;
            }
            if (isInvalidInput) {
                return 'The message is too long';
            }
            return 'Send message';
        }, ...(ngDevMode ? [{ debugName: "submitButtonTooltip" }] : []));
        this.isInputDisabled = computed(() => {
            const isOverFileLimit = this.isOverFileLimit();
            const oversizedFile = this.oversizedFile();
            const unsupportedFile = this.unsupportedFile();
            const isInvalidInput = this.isInvalidInput();
            const textValue = this._textValue();
            return isOverFileLimit || !!oversizedFile || !!unsupportedFile || isInvalidInput || !textValue;
        }, ...(ngDevMode ? [{ debugName: "isInputDisabled" }] : []));
    }
    ngAfterViewInit() {
        const dropdown = this.dropdownMenu();
        if (dropdown) {
            this._dropdownHelperService.setCloseHandler(dropdown.nativeElement, () => {
                if (this.isDropdownOpen()) {
                    this.isDropdownOpen.set(false);
                }
            });
        }
    }
    toggleDropdown() {
        this.isDropdownOpen.update((x) => !x);
    }
    openSmartCompareModal() {
        this.isDropdownOpen.set(false);
        const smartCompareModal = this.smartCompareModal();
        if (smartCompareModal) {
            smartCompareModal.open();
        }
    }
    onSmartCompareSubmit(payload) {
        this.sendMessage.emit({
            text: payload.promptText,
            files: [],
            smartCompareSecurityIds: payload.securityIds,
        });
    }
    onFileChange(event) {
        const target = event.target;
        if (target.files) {
            this.addFiles(Array.from(target.files));
        }
        this.clearFileInput();
    }
    /**
     * Appends files (from the picker or a drag-and-drop) to the upload list, de-duplicating against
     * what's already there. Size/type/count are validated reactively by the computed signals above.
     */
    addFiles(newFiles) {
        if (this.fileUploadDisabled()) {
            return;
        }
        this.uploadedFiles.update((existing) => this.getUniqueFiles([...existing, ...newFiles]));
    }
    onDragOver(event) {
        if (!this.dragDropEnabled() || !isFileDragEvent(event)) {
            return;
        }
        // Prevent default so the browser fires a `drop` event instead of navigating to/opening the file.
        event.preventDefault();
        // Cancelling the browser default above is what makes the drop a no-op; skip the highlight so the
        // chat bar offers no drop affordance.
        if (this.fileUploadDisabled()) {
            return;
        }
        const { dataTransfer } = event;
        if (dataTransfer) {
            dataTransfer.dropEffect = 'copy';
        }
        this.isDragOver.set(true);
    }
    onDragLeave(event) {
        // `dragleave` also fires when moving between child elements; only clear the highlight once the
        // cursor has actually left the chat bar.
        const relatedTarget = event.relatedTarget;
        if (!relatedTarget || !this._hostElement.nativeElement.contains(relatedTarget)) {
            this.isDragOver.set(false);
        }
    }
    onDrop(event) {
        if (!this.dragDropEnabled() || !isFileDragEvent(event)) {
            return;
        }
        event.preventDefault();
        this.isDragOver.set(false);
        const droppedFiles = event.dataTransfer?.files;
        if (droppedFiles && droppedFiles.length > 0) {
            this.addFiles(Array.from(droppedFiles));
        }
    }
    /**
     * Attaches images pasted from the clipboard (screenshots, copied browser images). When the clipboard
     * also carries plain text (e.g. an Excel range, which includes both a text and an image rendition),
     * the text paste wins and nothing is attached.
     */
    onPaste(event) {
        const { clipboardData } = event;
        if (!clipboardData) {
            return;
        }
        const images = Array.from(clipboardData.files).filter((file) => file.type.startsWith('image/'));
        if (images.length === 0 || clipboardData.types.includes('text/plain')) {
            return;
        }
        event.preventDefault();
        this.addFiles(images);
    }
    getUniqueFiles(files) {
        return files.filter((file, index) => files.findIndex((f) => f.name === file.name &&
            f.size === file.size &&
            f.type === file.type &&
            f.lastModified === file.lastModified) === index);
    }
    removeFile(fileIndex) {
        this.uploadedFiles.update((files) => files.filter((_, i) => i !== fileIndex));
    }
    onEnter(event) {
        if (this.isInputDisabled()) {
            event.preventDefault();
            return;
        }
        if (!event.shiftKey) {
            event.preventDefault();
            this.submit();
        }
    }
    ngOnDestroy() {
        const audioInput = this.audioInput();
        if (audioInput) {
            audioInput.cancelTranscription();
        }
    }
    submit() {
        this.sendMessage.emit({ text: this.textFormControl.value, files: this.uploadedFiles() });
        this.textFormControl.setValue('');
        this.uploadedFiles.update(() => []);
    }
    /**
     * Populates the input with the given text (e.g. a selected saved prompt) without submitting, and focuses
     * it so the user can edit placeholders before sending.
     */
    setText(text) {
        this.textFormControl.setValue(text);
        const textarea = this.textInput()?.nativeElement;
        if (textarea) {
            textarea.focus();
            textarea.setSelectionRange(text.length, text.length);
        }
    }
    clearFileInput() {
        const fileInput = this.fileInput();
        if (fileInput) {
            fileInput.nativeElement.value = '';
        }
    }
    startTranscription() {
        this.isTranscribing.set(true);
        // wait for component to render, then trigger transcription
        setTimeout(() => this.audioInput()?.startTranscription());
    }
    onTranscriptionCancel() {
        this.isTranscribing.set(false);
    }
    onTranscribedText(text) {
        this.textFormControl.setValue(text.trim());
        this.isTranscribing.set(false);
    }
}
AgentUserInputComponent.MAX_INPUT_LENGTH = 8000;
AgentUserInputComponent.ɵfac = function AgentUserInputComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AgentUserInputComponent)(); };
AgentUserInputComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: AgentUserInputComponent, selectors: [["ycn-agent-user-input"]], viewQuery: function AgentUserInputComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuerySignal(ctx.dropdownMenu, _c0, 5);
        i0.ɵɵviewQuerySignal(ctx.smartCompareModal, _c1, 5);
        i0.ɵɵviewQuerySignal(ctx.fileInput, _c2, 5);
        i0.ɵɵviewQuerySignal(ctx.audioInput, _c3, 5);
        i0.ɵɵviewQuerySignal(ctx.textInput, _c4, 5);
    } if (rf & 2) {
        i0.ɵɵqueryAdvance(5);
    } }, hostBindings: function AgentUserInputComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("dragover", function AgentUserInputComponent_dragover_HostBindingHandler($event) { return ctx.onDragOver($event); })("dragleave", function AgentUserInputComponent_dragleave_HostBindingHandler($event) { return ctx.onDragLeave($event); })("drop", function AgentUserInputComponent_drop_HostBindingHandler($event) { return ctx.onDrop($event); })("paste", function AgentUserInputComponent_paste_HostBindingHandler($event) { return ctx.onPaste($event); });
    } }, inputs: { maxAudioCanvasWidth: [1, "maxAudioCanvasWidth"], showNewChatButton: [1, "showNewChatButton"], compactLayout: [1, "compactLayout"], dragDropEnabled: [1, "dragDropEnabled"] }, outputs: { openNewChat: "openNewChat", sendMessage: "sendMessage", openSavedPrompts: "openSavedPrompts" }, decls: 13, vars: 4, consts: [["agentFileInput", ""], ["smartCompareModal", ""], ["audioInput", ""], ["textInput", ""], ["dropdownMenu", ""], [1, "d-flex", "justify-content-between", "w-full"], [1, "form-control-colors", "relative"], [1, "agent-drop-overlay", "absolute", "top-0", "left-0", "right-0", "bottom-0", "d-flex", "align-items-center", "justify-content-center", "text-small"], [1, "section-ai-input-files", 3, "section-ai-input-files-narrow"], [1, "d-flex", "justify-content-between", "align-items-center", "flex-wrap"], [1, "flex-auto", 3, "placeholder", "inputText", "maxCanvasWidth"], [1, "text-smallest", "text-center", "text-gray-30", "mt-1"], ["type", "file", "multiple", "", "hidden", "", 3, "change"], [3, "submitCompare"], [1, "btn", "btn-transparent-rounded", 3, "click"], ["name", "icon-add", "ycnIcon", ""], [1, "text-smallest"], ["name", "icon-attach", "ycnIcon", ""], [1, "section-ai-input-files"], [1, "d-flex", "flex-wrap", "pt-10"], [1, "plate-container"], [1, "plate", "plate-thin", "plate-noshadow", "plate-white"], [1, "plate-header", "width-full"], [1, "plate-title", "min-width-0"], [1, "plate-title-icon"], ["ycnIcon", "", 3, "name"], [1, "plate-title-name", "min-width-0", "text-ellipsis"], [1, "plate-controls"], [1, "btn", "btn-xs", "btn-circle", "btn-transparent", "btn-lightgray", "plate-control", "btn-close", 3, "click"], ["name", "icon-close", "ycnIcon", ""], [1, "flex-auto", 3, "transcribedText", "transcriptionCancel", "placeholder", "inputText", "maxCanvasWidth"], [1, "form-control-autosize", "max-rows-5", "relative", "flex-auto"], ["placeholder", "Ask Y...", "rows", "1", 1, "field-input", "border-0", "ng-pristine", "ng-untouched", "ng-valid", "ng-empty", 3, "keydown.enter", "formControl"], [1, "d-flex", "align-items-end", "ml-auto", "pt-1", "pr-2", "pb-1"], [1, "d-flex", "align-items-center", "justify-content-between"], [1, "d-flex", "align-items-center", "mr-1"], [1, "dropdown", "mr-1", 3, "show", "ycnAutoDropDirection"], ["ycnTooltip", "", 1, "btn", "btn-24", "btn-circle", "btn-transparent2", "btn-lightgray", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["name", "icon-microphone", "ycnIcon", ""], ["ycnTooltip", "", 1, "d-inline-block", 3, "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], [1, "btn", "btn-32", "btn-circle", "btn-ai-prompt", 3, "click", "disabled"], ["name", "icon-update", "ycnIcon", ""], ["ycnTooltip", "", 1, "btn", "btn-24", "btn-circle", "btn-transparent2", "btn-lightgray", "mr-1", 3, "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["ycnTooltip", "", 1, "btn", "btn-24", "btn-circle", "btn-transparent2", "btn-lightgray", "mr-1", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], [1, "dropdown", "mr-1", 3, "ycnAutoDropDirection"], ["role", "button", "aria-haspopup", "true", 1, "btn", "btn-24", "btn-circle", "btn-transparent2", "btn-lightgray", "dropdown-toggle", 3, "click"], ["name", "icon-add-circle", "ycnIcon", ""], [1, "dropdown-menu", "dropdown-menu-with-icons"], [1, "dropdown", "dropdown-nested"], [1, "dropdown-item", "dropdown-toggle"], ["name", "icon-compare-ai", "ycnIcon", ""], [1, "dropdown-item-text"], [1, "dropdown-menu", "dropdown-menu-right"], ["href", "javascript:void(0)", 1, "dropdown-item", 3, "click"], ["name", "icon-list-checked", "ycnIcon", ""], [1, "dropdown-divider"]], template: function AgentUserInputComponent_Template(rf, ctx) { if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵconditionalCreate(0, AgentUserInputComponent_Conditional_0_Template, 6, 0, "div", 5);
        i0.ɵɵelementStart(1, "div", 6);
        i0.ɵɵconditionalCreate(2, AgentUserInputComponent_Conditional_2_Template, 3, 0, "div", 7);
        i0.ɵɵconditionalCreate(3, AgentUserInputComponent_Conditional_3_Template, 5, 2, "div", 8);
        i0.ɵɵelementStart(4, "div", 9);
        i0.ɵɵconditionalCreate(5, AgentUserInputComponent_Conditional_5_Template, 2, 3, "ycn-audio-transcription-input", 10)(6, AgentUserInputComponent_Conditional_6_Template, 13, 20);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(7, "div", 11);
        i0.ɵɵtext(8, " AI can make mistakes. Please double-check responses.\n");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(9, "input", 12, 0);
        i0.ɵɵlistener("change", function AgentUserInputComponent_Template_input_change_9_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onFileChange($event)); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "ycn-agent-smart-compare-modal", 13, 1);
        i0.ɵɵlistener("submitCompare", function AgentUserInputComponent_Template_ycn_agent_smart_compare_modal_submitCompare_11_listener($event) { i0.ɵɵrestoreView(_r1); return i0.ɵɵresetView(ctx.onSmartCompareSubmit($event)); });
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.showNewChatButton() ? 0 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.isDragOver() ? 2 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.uploadedFiles().length > 0 ? 3 : -1);
        i0.ɵɵadvance(2);
        i0.ɵɵconditional(ctx.isTranscribing() ? 5 : 6);
    } }, dependencies: [IconModule, i1.IconDirective, ReactiveFormsModule, i2.DefaultValueAccessor, i2.NgControlStatus, i2.FormControlDirective, TooltipModule, i3.TooltipDirective, AudioTranscriptionInputComponent,
        AgentSmartCompareModalComponent,
        AutoDropDirectionModule, i4.AutoDropDirectionDirective], encapsulation: 2, changeDetection: 0 });
